module.exports = __webpack_public_path__ + "img/product2.5d8541bb.png";